<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-21 09:09:10
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-02-07 16:17:05
 * @FilePath: \H5\src\views\advertising.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="Photo" @click="hAbv" v-if="list.advertising_config_list">
    <div class="adv">
      广告
    </div>
    <div class="pic">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in list.advertising_config_list" :key="index">
            <img :src="item.advertising_image" alt="" class="img" style="width: 100%; height: 100%;">
         </van-swipe-item>
       </van-swipe>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
  export default {
    data() {
      return {
        list: [],
        url: '',
      };
    },
    created() {
      this.list = JSON.parse(
      window.localStorage.getItem("reData")
    );
    this.list.advertising_config_list.forEach(item => {
      this.url = item.jump_url
    })
    console.log("gggg", this.list);
    },
    methods: {
      async hAbv () {
        let data = {
        merchant_id: this.list.wx_merchant_id,
        path: this.url
      }
      await axios.post(
        'https://apigateway.klyun.com.cn/chaintea/industry/v1.0.0/api/myshop/CreateWXScheme',
         data
      ).then(res => {
        console.log(res.data);
        if(res.data.message.code === 200) {
          location.href = res.data.data.openlink
        }
      })
      }
    }
  }
</script>

<style lang="scss" scoped>
.Photo {
  position: relative;
  width: 640px;
  height: 188px;
  margin-bottom: 20px;
  .my-swipe {
    width: 640px;
    height: 188px;
  }
  
  margin-top: 28px;
  .adv {
    text-align: center;
    width: 54px;
    height: 26px;
    background: #000;
    opacity: 0.38;
    border-radius: 0px;
    position: absolute;
    top: 0px;
    right: 0;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 26px;
    color: #FFFFFF;
    opacity: 1;
    z-index: 99;
  }
}
</style>